import {
  GreyGrey30,
  GreyWhite,
  ShadowM,
  Box
} from '@sequencehq/core-components'
import { CSSProperties, ReactNode } from 'react'

export const Section = ({
  children,
  ...props
}: {
  children: ReactNode
  'data-testid'?: string
  width?: CSSProperties['width']
  userSelect?: CSSProperties['userSelect']
}) => {
  return (
    <Box
      {...props}
      borderRadius="8px"
      border={`1px solid ${GreyGrey30}`}
      boxShadow={ShadowM}
      backgroundColor={GreyWhite}
    >
      {children}
    </Box>
  )
}
